<template>
  <div class="dashboard-content">
    <b-container>
      <page-headline>Dashboard</page-headline>
      <b-row>
        <b-col>
          <b-row>
            <b-col cols="12" sm="6" md="4" lg="3" v-if="hasAnyOfTheseRoles(['supplier_buying', 'supply_agent'])" class="btn-col">
              <b-button variant="outline-primary" block :to="{ name: 'selling-offers' }">B2B-Sale</b-button>
            </b-col>
            <b-col cols="12" sm="6" md="4" lg="3" v-if="hasAnyOfTheseRoles(['supplier_selling', 'supply_agent'])" class="btn-col">
              <b-button variant="outline-primary" block :to="{ name: 'buying-demand' }">Demand</b-button>
            </b-col>
            <b-col cols="12" sm="6" md="4" lg="3" v-if="hasAnyOfTheseRoles(['supplier_bulk'])" class="btn-col">
              <b-button variant="outline-success" block :to="{ name: 'bulk-upload' }">Stocklist Upload</b-button>
            </b-col>
            <b-col cols="12" sm="6" md="4" lg="3" v-if="hasAnyOfTheseRoles(['supply_agent'])" class="btn-col">
              <b-button variant="outline-primary" block :to="{ name: 'admin' }">Admin</b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { hasAnyOfTheseRoles } from 'src/auth';
import PageHeadline from 'Components/common/PageHeadline';

export default {
  name: 'Dashboard',
  components: { PageHeadline },
  methods: {
    hasAnyOfTheseRoles(roles) {
      return hasAnyOfTheseRoles(roles);
    },
  },
};
</script>

<style scoped>
h1 {
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: 2px;
}

.dashboard-content {
  min-height: 300px;
}
.btn-col {
  margin-bottom: 1em;
}
</style>
